import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

declare global {
  interface Window {
    dataLayer: Array<{ event?: string; [key: string]: any }>;
    gtag?: (
      command: 'config' | 'event' | 'set' | 'js',
      targetId?: string | { [key: string]: any },
      params?: Record<string, any>
    ) => void;
  }
}

const useAnalytics = () => {
  const GA_ID = process.env.REACT_APP_GA_ID;
  const isProd = process.env.REACT_APP_ENV === 'production';

  function initGA() {
    if (!isProd || !GA_ID) return;
    if (window.gtag) return;

    const script = document.createElement('script');
    script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`;
    script.async = true;
    document.head.appendChild(script);

    window.dataLayer = window.dataLayer || [];
    window.gtag = function () {
      window.dataLayer.push(arguments);
    };

    window.gtag('js', new Date());
    window.gtag('config', GA_ID);
  }

  const trackEvent = (action: string, params?: Record<string, any>) => {
    if (!isProd || !window.gtag) return;
    window.gtag('event', action, params || {});
  };

  const trackPageView = (path: string) => {
    if (!isProd || !window.gtag) return;
    window.gtag('config', GA_ID, { page_path: path });
  };

  useEffect(() => {
    initGA();
  }, []);

  return { trackEvent, trackPageView };
};

export default useAnalytics;
